import { render, staticRenderFns } from "./imageIcon.vue?vue&type=template&id=0edb7a20&"
import script from "./imageIcon.vue?vue&type=script&lang=js&"
export * from "./imageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports